import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import React from 'react';
import { observer } from 'mobx-react';
import { readConfObject } from '@jbrowse/core/configuration';
// locals
import { isUTR } from './util';
import Arrow from './Arrow';
var utrHeightFraction = 0.65;
function Box(props) {
  var feature = props.feature,
    region = props.region,
    config = props.config,
    featureLayout = props.featureLayout,
    bpPerPx = props.bpPerPx,
    topLevel = props.topLevel;
  var start = region.start,
    end = region.end;
  var screenWidth = (end - start) / bpPerPx;
  var width = (feature.get('end') - feature.get('start')) / bpPerPx;
  var _featureLayout$absolu = featureLayout.absolute.left,
    left = _featureLayout$absolu === void 0 ? 0 : _featureLayout$absolu;
  var _featureLayout$absolu2 = featureLayout.absolute,
    _featureLayout$absolu3 = _featureLayout$absolu2.top,
    top = _featureLayout$absolu3 === void 0 ? 0 : _featureLayout$absolu3,
    _featureLayout$absolu4 = _featureLayout$absolu2.height,
    height = _featureLayout$absolu4 === void 0 ? 0 : _featureLayout$absolu4;
  if (left + width < 0) {
    return null;
  }
  if (isUTR(feature)) {
    top += (1 - utrHeightFraction) / 2 * height;
    height *= utrHeightFraction;
  }
  var leftWithinBlock = Math.max(left, 0);
  var diff = leftWithinBlock - left;
  var widthWithinBlock = Math.max(2, Math.min(width - diff, screenWidth));
  // if feature has parent and type is intron, then don't render the intron
  // subfeature (if it doesn't have a parent, then maybe the introns are
  // separately displayed features that should be displayed)
  return feature.parent() && feature.get('type') === 'intron' ? null : React.createElement(React.Fragment, null, topLevel ? React.createElement(Arrow, _objectSpread({}, props)) : null, React.createElement("rect", {
    "data-testid": "box-".concat(feature.id()),
    x: leftWithinBlock,
    y: top,
    width: widthWithinBlock,
    height: height,
    fill: isUTR(feature) ? readConfObject(config, 'color3', {
      feature: feature
    }) : readConfObject(config, 'color1', {
      feature: feature
    }),
    stroke: readConfObject(config, 'outline', {
      feature: feature
    })
  }));
}
export default observer(Box);